import Page from 'modules/Home'

export default Page

